import { Box, Title } from '@factorialco/deprecated-design-system'
import { BenefitsUsagePageFeaturesAvailabilityDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { UsageDataCollection } from './UsageDataCollection'

const SpendingPage = () => {
  useEffect(() => {
    track(trackingEvents.benefits.openBenefitsUsagePage)
  }, [])

  // Fetch feature availability to control training column
  const { data: featureData, loading: featureLoading } = useQuery(
    BenefitsUsagePageFeaturesAvailabilityDocument,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const isPortugal = featureData?.companies.featureAvailabilitiesConnection.nodes.find(
    (node) => node.id === 'benefits_core_pt'
  )?.available

  const includeTraining =
    featureData?.companies.featureAvailabilitiesConnection.nodes.find(
      (node) => node.id === 'benefits_trainings'
    )?.available && !isPortugal

  const includeHealthcare =
    featureData?.companies.featureAvailabilitiesConnection.nodes.find(
      (node) => node.id === 'benefits_healthcare'
    )?.available && !isPortugal

  return (
    <ResponsivePage.Body>
      <Box gap="s32">
        <Title
          variant="400"
          title={i18n.t('benefits.tabs.usage.page.title')}
          description={i18n.t('benefits.tabs.usage.page.description')}
        />

        <UsageDataCollection
          includeTraining={includeTraining}
          includeHealthcare={includeHealthcare}
        />
      </Box>
    </ResponsivePage.Body>
  )
}

export default SpendingPage
